// components/markdown/Image.tsx
import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import type { BaseCustomProps } from './types';

interface ImageProps extends BaseCustomProps {
  src?: string;
  alt?: string;
  title?: string;
  width?: string | number;
  height?: string | number;
}

export const Image: React.FC<ImageProps> = ({ 
  src, 
  alt = '', 
  title, 
  width, 
  height, 
  className,
  ...props 
}) => {
    const [error, setError] = useState<string | null>(null);
    const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
        console.error('Error loading image:', event.currentTarget.src);
        setError(`Failed to load image from: ${event.currentTarget.src}`);
        // Optionally, you could set a placeholder image here:
        // event.currentTarget.src = '/placeholder.png';
      };
    
      if (!src) {
        console.error('Image component missing src attribute');
        return <div className={twMerge('text-red-500', className)}>Image component missing src attribute</div>;
      }
      if (error) {
        return (
          <div className={twMerge('text-red-500', className)}>
            {error}
          </div>
        );
      }
      
  return (
    <Image
      src={src}
      alt={alt || ''}
      title={title}
      width={Number(width) || 500} // Default width if not provided
      height={Number(height) || 300} // Default height if not provided
      className={twMerge('max-w-full', className)}
      {...props}
    />
  );
};